import { render, staticRenderFns } from "./ScrollUpButton.vue?vue&type=template&id=49278f46&scoped=true"
import script from "./ScrollUpButton.vue?vue&type=script&lang=js"
export * from "./ScrollUpButton.vue?vue&type=script&lang=js"
import style0 from "./ScrollUpButton.vue?vue&type=style&index=0&id=49278f46&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49278f46",
  null
  
)

export default component.exports